import Model from "../Model";

class RepresentantsUser extends Model{

    buildUrl ({ param }) {
        return ['allemployeeview/getallemployeedatabyuser', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new RepresentantsUser;